import { Action, ActionReducer } from '@ngrx/store';
import { SiteIdAction, SiteIdActionType } from '../../actionstypes/selected-id/site-id.actiontype';

const initialState = -1;

const siteIdReducer = (state = initialState, action: SiteIdActionType): number => {
  switch (action.type) {
    case SiteIdAction.Set:
      return action.payload;

    case SiteIdAction.Reset:
      return -1;

    case SiteIdAction.Sync:
      if (state === -1) {
        return state;
      }

      if (!action.payload.includes(state)) {
        return -1;
      }

      return state;

    default:
      return state;
  }
};

export default siteIdReducer as ActionReducer<number, Action<string>>;
